import { createStandardAction } from 'typesafe-actions'

type NavigationDirection = 1 | -1

export const navigate = createStandardAction('navigate')<NavigationDirection>()
